import { Upload24Icon } from "@kaltura/ds-react-icons";
import { Button } from "@kaltura/ds-react-components";
import { CreationToolButtonProps } from "@kaltura/mediaspace-shared-search-and-select";

/**
 * Upload creation tool button for the quiz creation page
 */
export const UploadCreationToolButton = ({ label, ...rest }: CreationToolButtonProps) => {
    return (
        <Button {...rest} startIcon={<Upload24Icon />}>
            {label}
        </Button>
    );
};
